import { render, staticRenderFns } from "./MonthlyLeaderboardTable.vue?vue&type=template&id=4d50c84c&scoped=true"
import script from "./MonthlyLeaderboardTable.vue?vue&type=script&lang=ts"
export * from "./MonthlyLeaderboardTable.vue?vue&type=script&lang=ts"
import style0 from "./MonthlyLeaderboardTable.vue?vue&type=style&index=0&id=4d50c84c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d50c84c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d50c84c')) {
      api.createRecord('4d50c84c', component.options)
    } else {
      api.reload('4d50c84c', component.options)
    }
    module.hot.accept("./MonthlyLeaderboardTable.vue?vue&type=template&id=4d50c84c&scoped=true", function () {
      api.rerender('4d50c84c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/admin/components/MonthlyLeaderboardTable.vue"
export default component.exports